import React from 'react';
import { InterPoint } from '@saviynt/common';
import { Chip, Tooltip } from '@saviynt/design-system';

import { useInvertedLocalize } from '../../hooks';

const RISK_ACT_VS_POT_MAP: Record<string, string> = {
  'Actual Risk': 'warning',
  'Potential Risk': 'info',
  'Not Calculated': 'neutral',
} as const;

interface ActVsPotChipProps {
  value: string | null;
  isPrefixInterpoint?: boolean;
}

/**
 * For actual vs potential chip
 */
function SodActVsPotChip({ value, isPrefixInterpoint }: ActVsPotChipProps) {
  const l = useInvertedLocalize();

  const label =
    !value || !Object.keys(RISK_ACT_VS_POT_MAP).includes(value)
      ? 'Not Calculated'
      : value;
  const labelColor = RISK_ACT_VS_POT_MAP[label];

  let tooltipText = 'Actual vs Potential status is not calculated';

  if (value === 'Actual Risk') {
    tooltipText =
      'The user has performed actions using entitlements from all functions involved in the risk. This is a confirmed SoD violation based on usage data.';
  }

  if (value === 'Potential Risk') {
    tooltipText =
      'The user has access to conflicting entitlements but has only used a subset. A violation could occur but hasn’t yet been confirmed by full usage.';
  }

  return (
    <>
      <Tooltip
        trigger={
          <Chip
            size='xSmall'
            kind='subtleFilled'
            label={l(label)}
            color={labelColor}
          />
        }
        text={l(tooltipText)}
        placement='bottom'
        isPortalEnabled
      />
      {isPrefixInterpoint && <InterPoint color='neutralBold' font='body2' />}
    </>
  );
}

SodActVsPotChip.defaultProps = {
  isPrefixInterpoint: true,
};

export default SodActVsPotChip;
